import { render, staticRenderFns } from "./zhsy.vue?vue&type=template&id=ed74cf66&scoped=true&"
import script from "./zhsy.vue?vue&type=script&lang=js&"
export * from "./zhsy.vue?vue&type=script&lang=js&"
import style0 from "./zhsy.vue?vue&type=style&index=0&id=ed74cf66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed74cf66",
  null
  
)

export default component.exports